import React, { FC } from 'react';

import { useDispatch } from 'react-redux';

import { GettingStartedComponent } from 'components/DataDisplay/Utils/GettingStarted/GettingStartedComponent';
import { actions } from 'containers/Setup/Integrations/slice';
import { IntegrationsTabs } from 'containers/Setup/Integrations/types';

interface Props {
  setHasClients(val: boolean);
}

export const GettingStartedWithThirdPartyIntegration: FC<Props> = props => {
  const dispatch = useDispatch();
  const { setHasClients } = props;
  const onClick = tab => {
    setHasClients(true);
    dispatch(actions.updateCurrentTab(tab));
  };

  const steps = [
    {
      label: 'Enable SSO for Ariksa login',
      key: 'sso',
      onClick: () => onClick(IntegrationsTabs.Sso),
    },
    {
      label: 'Add IdP used for federated access to cloud & SaaS',
      key: 'saas',
      onClick: () => onClick(IntegrationsTabs.Saas),
    },
    {
      label: 'Add integrations to receive notifications (ex: Slack)',
      key: 'notification',
      onClick: () => onClick(IntegrationsTabs.Slack),
    },
    {
      label: 'Add ticketing integrations for response (ex: Jira)',
      key: 'ticketing',
      onClick: () => onClick(IntegrationsTabs.Servicenow),
    },
    {
      label: 'Send information to SIEM for enrichment',
      key: 'siem',
      onClick: () => onClick(IntegrationsTabs.Siem),
    },
  ];

  return (
    <GettingStartedComponent header="3rd Party Integrations" steps={steps} />
  );
};
